import React, { ForwardedRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedElement,
  updateSelectedInteraction,
} from "./../../../app/slices/TrainingSlice";
import { arrayMove } from "@dnd-kit/sortable";
import PiDragContainer, {
  ContainerStyle,
} from "../../../components/PiDragContainer";

import { IConversation } from "../../../models/interactions/Conversation";
import { IMessageBubble } from "../../../models/interactions/MessageBubble";
import { IEmotionBubble } from "../../../models/interactions/EmotionBubble";
import { ConversationChatLine } from "./ConversationChatLine";

interface ConversationPreviewMessageViewProps {
  selectedLineId?: string;
  onSelectLine: (message: IMessageBubble | IEmotionBubble) => void;
  onDeleteLine: (message: IMessageBubble | IEmotionBubble) => void;
}

const ConversationPreviewMessageView = forwardRef<
  HTMLDivElement,
  ConversationPreviewMessageViewProps
>(({ selectedLineId, onSelectLine, onDeleteLine }, ref: ForwardedRef<HTMLDivElement>) => {
  const conversation = useSelector(selectSelectedElement) as IConversation;
  const dispatch = useDispatch();

  // Design: Design Studio `screens/lookat-rework/cv2c-chat-closed.html`.
  const msgs = conversation?.messages.map((msg) => (
    <ConversationChatLine
      key={msg.id}
      line={msg}
      conversationId={conversation.id}
      isSelected={msg.id === selectedLineId}
      onSelect={() => onSelectLine(msg)}
      onDelete={() => onDeleteLine(msg)}
    />
  ));

  function onHandleDragEnd(prevIndex: number, newIndex: number) {
    var originalMessages = [...conversation.messages];

    const newConversation = { ...conversation };
    newConversation.messages = arrayMove(originalMessages, prevIndex, newIndex);

    dispatch(updateSelectedInteraction(newConversation));
  }

  return (
    <div
      className="flex flex-col flex-1 min-h-0 gap-4 py-4 border-solid border-x-0 border-t-0 border-b-2 border-interaction-primary-washed pit-scrollbar overflow-y-auto"
      ref={ref}
    >
      <PiDragContainer
        onHandleDragEnd={onHandleDragEnd}
        containerElements={msgs}
        uniqueIds={conversation.messages.map((m) => m.id)}
        containerStyle={ContainerStyle.Default}
      />
    </div>
  );
});

export default ConversationPreviewMessageView;
